<style lang="less" scoped>
  .append-button {
    background-color: #fff !important;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
</style>

<style lang="less">
  .sc-file-input {
    .el-input-group__append {
      padding: 0;
      background: #fff;
    }
  }
</style>

<template lang="pug">
  el-input.sc-file-input(:value="fileName", :placeholder="placeholder", readonly)
    sc-file-upload-button.append-button(slot="append", @upload="upload") 찾아보기
</template>

<script>
import ScFileUploadButton from '@/components/ScFileUploadButton.vue';

export default {
  components: {
    ScFileUploadButton,
  },
  props: {
    placeholder: {
      type: String,
      default: '파일 찾기',
    },
    fileName: {
      type: String,
    },
  },
  methods: {
    upload(e) {
      this.$emit('upload', e);
    },
  },
};
</script>
